import { Component } from '@angular/core';

@Component({
  selector: 'app-cancelled-cases-list',
  templateUrl: './cancelled-cases-list.component.html',
  styleUrls: ['./cancelled-cases-list.component.css']
})
export class CancelledCasesListComponent {

}
